import { useEffect } from "react";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { useStore } from "../../app/stores/store";
import BoardCard from "./BoardCard";
import { observer } from "mobx-react-lite";
import { router } from "../../app/router/Routes";
import AddButton from "../../app/common/form/AddButton";
import Divider from "@mui/material/Divider";

export default observer(function BoardScreen() {

    const { boardStore } = useStore();
    const { boards, templateBoards, loadBoards, loadTemplateBoards, setSelectedBoard, loading } = boardStore;

    useEffect(() => {
        loadBoards()
        loadTemplateBoards()
    }, [loadBoards])

    return (
        <div>
            <Box sx={{ overflowY: 'auto' }} height={'100%'}>
                <Grid container alignContent='flex-start'>
                    <Grid item xs={4}>
                        <Typography variant="h4">Meine Boards</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <AddButton onClick={() => router.navigate('/boards/new')} />
                    </Grid>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Grid item container spacing={2}>
                            {boards?.map((board) => {
                                return (<Grid item key={`gridItem_${board.id}`}>
                                    <BoardCard board={board} setSelectedBoard={setSelectedBoard} />
                                </Grid>)
                            })}
                        </Grid>
                    )}
                </Grid>

                <Divider style={{ "margin": "32px 0" }} />

                <Grid container alignContent='flex-start'>
                    <Grid item xs={4}>
                        <Typography variant="h4">Standardisierte Boards</Typography>
                    </Grid>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Grid item container spacing={2}>
                            {templateBoards?.map((board) => {
                                return (<Grid item key={`gridItem_${board.id}`}>
                                    <BoardCard
                                        board={board}
                                        setSelectedBoard={setSelectedBoard}
                                    />
                                </Grid>)
                            })}
                        </Grid>
                    )}
                </Grid>
            </Box>
        </div>
    );
});